import fetchWithAuth from './base';
import { ListResponse } from '@/types/common';
import { TargetPage } from '@/types/targetPage';

export const getTargetPages = async ({
  clientId,
  startingAfter,
  endingBefore,
  limit,
  search,
  pageStatus,
}: {
  clientId: string;
  startingAfter?: string;
  endingBefore?: string;
  limit?: number;
  search?: string;
  pageStatus?: string;
}): Promise<ListResponse<TargetPage>> => {
  const params = new URLSearchParams();
  if (startingAfter) {
    params.append('starting_after', startingAfter);
  }
  if (endingBefore) {
    params.append('ending_before', endingBefore);
  }
  if (limit) {
    params.append('limit', limit.toString());
  }
  if (search) {
    params.append('search', search);
  }
  if (pageStatus) {
    params.append('page_status', pageStatus);
  }

  const response = await fetchWithAuth(`/api/client/${clientId}/target_page?${params.toString()}`, {
    method: 'GET',
  });
  return response.json();
};

export const getTargetPage = async (clientId: string, id: string): Promise<TargetPage> => {
  const response = await fetchWithAuth(`/api/client/${clientId}/target_page/${id}`, {
    method: 'GET',
  });
  return response.json();
};

export const createTargetPage = async (clientId: string, data: Partial<TargetPage>) => {
  const response = await fetchWithAuth(`/api/client/${clientId}/target_page`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  return response.json();
};

export const updateTargetPage = async (clientId: string, id: string, data: Partial<TargetPage>) => {
  const response = await fetchWithAuth(`/api/client/${clientId}/target_page/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  return response.json();
};

export const deleteTargetPage = async (clientId: string, id: string): Promise<void> => {
  await fetchWithAuth(`/api/client/${clientId}/target_page/${id}`, {
    method: 'DELETE',
  });
};
